import Vue from 'vue'
import App from './App'
import router from './router'
import Conf from './router/Conf'
import 'vant/lib/index.css'
import qs from 'qs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
// import Vuex from "vuex"
import store from './store'
//在全局中引入
import globalWs from "./utils/Websocket"
import VueClipboard from 'vue-clipboard2'
import "@/assets/css/main.less";
import "@/assets/css/common.less";
import VueScroller from 'vue-scroller';

axios.defaults.withCredentials = true // 设置允许携带cookie


import {
  NavBar,
  NoticeBar,
  Toast,
  Popup,
  Picker,
  Dialog,
  Button,
  Icon,
  Image,
  Field,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Uploader,
  TabbarItem,
  Tabbar,
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  IndexBar,
  IndexAnchor,
  SwipeCell,
  Tag,
  Switch,
  Circle,
  CountDown,
  Loading,
  PullRefresh,
  Tab,
  Tabs,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Slider,
  Collapse,
  CollapseItem
} from 'vant';
import VsTree from 'vs-tree';
import {
  Range
} from 'mint-ui';
import 'mint-ui/lib/style.css'
import 'vs-tree/lib/style/index.css';


// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            // 这里可以根据code值进行判断处理，需要与后端协商统一
			if(response.data.code == 401) {
				Toast.fail({
				  message: response.data.msg
				})
				window.localStorage.clear();
				setTimeout(() => {
					router.replace({
						path: '/login'
					});
				}, 1000);

            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
					Toast.fail({
						message: response.data.msg
					})
                    // 清除token
					window.localStorage.clear();
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login'
                        });
                    }, 1000);
                    break;


                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    router.replace({
                        path: '/login'
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
					Toast.fail({
						message: response.data.msg
					})
            }
            return Promise.reject(error.response);
        }
    }
);


Vue.use(VsTree);
Vue.component(Range.name, Range);
Vue.use(NavBar).use(PullRefresh).use(Loading).use(NoticeBar).use(CountDown).use(Tag).use(Circle).use(Switch).use(Toast).use(Popup).use(Picker).use(Dialog).use(Button).use(Icon).use(Image).use(Field).use(Cell).use(CellGroup).use(Radio).use(RadioGroup).use(Uploader).use(TabbarItem).use(Tabbar).use(Row).use(Col).use(CheckboxGroup).use(Checkbox).use(IndexBar).use(IndexAnchor).use(Tab).use(Tabs).use(Loading).use(NoticeBar).use(CountDown).use(Tag).use(Circle).use(Switch).use(SwipeCell).use(Toast).use(Popup).use(Picker).use(Dialog).use(Button).use(Icon).use(Image).use(Field).use(Cell).use(CellGroup).use(Radio).use(RadioGroup).use(Uploader).use(TabbarItem).use(Tabbar).use(Row).use(Col).use(CheckboxGroup).use(Checkbox).use(IndexBar).use(IndexAnchor).use(Tab).use(Tabs).use(Loading).use(DropdownMenu).use(DropdownItem).use(TreeSelect).use(Slider);
Vue.use(VueScroller).use(Collapse).use(CollapseItem)
Vue.config.productionTip = false
Vue.prototype.Conf = Conf // 注册全局常量
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.websocket = globalWs // websocket挂载到原型
Vue.use(VueClipboard) // 复制粘贴功能
Vue.prototype.$store = store

import { VueJsonp } from 'vue-jsonp' 
Vue.use(VueJsonp)
// /* 初始化数据 */
store.dispatch('SYSTEM_INIT')


import * as filters from './filters/index' // 全局过滤器
// 注册全局实用程序过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// router.beforeEach((to, from, next) => {
//   //路由中设置的needLogin字段就在to当中 
//   if (window.localStorage.u_id + window.localStoragetoken) {
//     // console.log(to.path) //每次跳转的路径
//     if (to.path === '/login') {
//       //登录状态下 访问login.vue页面 会跳到index.vue
//       next({
//         path: '/'
//       });
//     } else {
//       next();
//     }
//   } else {
//     // 如果没有,访问任何页面。都会进入到 登录页
//     if (to.path === '/login') { // 如果是登录页面的话，直接next() -->解决注销后的循环执行bug
//       next();
//     } else { // 否则 跳转到登录页面
//       next({
//         path: '/login'
//       });
//     }
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js